import Head from 'next/head';
import type { JsonLdSchema } from 'utils/jsonld/types';

interface JsonLdProps {
  scriptKey: string;
  schema: JsonLdSchema;
}

// Escape `<` to neutralize any `</script>` sequence in CMS-sourced strings.
export const serialize = (schema: JsonLdSchema) =>
  JSON.stringify(schema).replace(/</g, '\\u003c');

export function JsonLd({ scriptKey, schema }: JsonLdProps) {
  return (
    <Head>
      <script
        type="application/ld+json"
        key={scriptKey}
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: serialize(schema) }}
      />
    </Head>
  );
}
